import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-progress-resume',
  templateUrl: './progress-resume.component.html',
  styleUrls: ['./progress-resume.component.scss']
})
export class ProgressResumeComponent implements OnInit {
  @Input() userProgress: any = null
  circleProgressOption: any = {
    radius: 60,
    space: -16, //?? must be equal
    outerStrokeGradient: false,
    outerStrokeWidth: 16, //?? must be equal
    outerStrokeColor: "#006EE9",
    innerStrokeColor: "#E5E5E5",
    innerStrokeWidth: 16, //?? must be equal
    animationDuration: 1000,
    showBackground: false,
    clockwise: true,
    startFromZero: true,
    lazy: true,
    titleColor: 'rgba(55, 64, 82, .5)',
    unitsColor: 'rgba(55, 64, 82, .5)',
    unitsFontSize: '23px',
    titleFontWeight: 'bold',
    showSubtitle: false,
  }

  constructor() { }

  ngOnInit(): void {
  }
}
